export default "__VITE_ASSET__475f87ed__"